module.exports = __webpack_public_path__ + "media/email/mr_sig-0591913c.png";